export const FIXED_SERVICE_CATEGORIES = ['DSL', 'FTTH', 'LITE TV', 'SAT TV'];
export const EMPLOYEE_SERVICE_CATEGORY = 'EMPLOYEE';
export const BILLING_TYPE_PREPAID = 'PREPAID';
export const CUSTOMER_ROLE_SPECIAL_CUSTOMER_CARE = 'special-customer-care';

export const STATUS_CODE_SUSPENDED = '50';
export const STATUS_CODE_SWITCHED_OFF = '60';
export const STATUS_CODE_DISCONNECT = '70';
export const UNSERVICEABLE_STATUS_CODES = [
  STATUS_CODE_SUSPENDED,
  STATUS_CODE_SWITCHED_OFF,
  STATUS_CODE_DISCONNECT,
];
